export default "__VITE_ASSET__07bc2273__"